import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_INVOICEROUTE_RESET = 'PUT_INVOICEROUTE_RESET';
export const PUT_INVOICEROUTE_LOADING = 'PUT_INVOICEROUTE_LOADING';
export const PUT_INVOICEROUTE_SUCCESS = 'PUT_INVOICEROUTE_SUCCESS';
export const PUT_INVOICEROUTE_REJECT = 'PUT_INVOICEROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const putInvoiceRouteReset = () => ({ type: PUT_INVOICEROUTE_RESET });
export const putInvoiceRouteLoading = () => ({ type: PUT_INVOICEROUTE_LOADING });
export const putInvoiceRouteSuccess = (payload) => ({ type: PUT_INVOICEROUTE_SUCCESS, payload });
export const putInvoiceRouteReject = (payload) => ({ type: PUT_INVOICEROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putInvoiceRouteRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/api/InvoiceRoutes`, options);
};


